"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCosmonaut = exports.CosmonautProvider = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("../core/client");
const CosmonautContext = react_1.createContext(new client_1.CosmonautClient());
const CosmonautProvider = ({ client, children, }) => {
    const _client = react_1.useRef(client !== null && client !== void 0 ? client : new client_1.CosmonautClient());
    return (react_1.default.createElement(CosmonautContext.Provider, { value: _client.current }, children));
};
exports.CosmonautProvider = CosmonautProvider;
function useCosmonaut() {
    return react_1.useContext(CosmonautContext);
}
exports.useCosmonaut = useCosmonaut;
